export default __webpack_public_path__ + "static/media/check-cycle.edcd332b.svg";